import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import HeldChart from '../HeldChart';
import SaleNotifications from '../SaleNotifications';
import TargetLabel from '../Target';

const startColorHex = '#0783FE';
const startColorRgb = [7, 131, 254];
const endColorRgb = [169, 28, 237];

const GradientBar = props => {
  const { eventId, percentage, showTarget, target, targetPercentage, heldQuantity } = props;

  const normalizedPercentage = Math.min(100, Math.max(0, percentage));
  const showLabelInsideChart = target !== 0 && target !== heldQuantity;

  const rgbToHex = (r, g, b) => {
    const rCopy = Math.max(0, Math.min(255, r));
    const gCopy = Math.max(0, Math.min(255, g));
    const bCopy = Math.max(0, Math.min(255, b));

    const toHex = value => {
      const hex = value.toString(16).toUpperCase();
      return hex.length === 1 ? `0${hex}` : hex;
    };

    return `#${toHex(rCopy)}${toHex(gCopy)}${toHex(bCopy)}`;
  };

  const interpolateColor = () => {
    const r = Math.round(startColorRgb[0] + (percentage / 100) * (endColorRgb[0] - startColorRgb[0]));
    const g = Math.round(startColorRgb[1] + (percentage / 100) * (endColorRgb[1] - startColorRgb[1]));
    const b = Math.round(startColorRgb[2] + (percentage / 100) * (endColorRgb[2] - startColorRgb[2]));

    return rgbToHex(r, g, b);
  };

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
        display: 'flex',
        gap: '10px',
      }}
    >
      <Box
        sx={{
          width: `${normalizedPercentage}%`,
          height: '35px',
          background: `linear-gradient(to right, ${startColorHex}, ${interpolateColor()})`,
          transition: 'width 0.5s ease',
          borderTopRightRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        {showTarget && <HeldChart percentage={targetPercentage} showLabel={showLabelInsideChart} target={target} />}
      </Box>
      <Box display="flex" alignItems="center" marginLeft="-24px" marginRight="-10px">
        <SaleNotifications eventId={eventId} />
      </Box>
      {showTarget && !showLabelInsideChart && <TargetLabel target={target} />}
    </Box>
  );
};

GradientBar.propTypes = {
  eventId: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  showTarget: PropTypes.bool.isRequired,
  target: PropTypes.number.isRequired,
  targetPercentage: PropTypes.number.isRequired,
  heldQuantity: PropTypes.number.isRequired,
};

export default GradientBar;
